import type { RouteRecordRaw, Router } from 'vue-router'
import { MODULE_ACCESS } from '@/modules/Core/constants/adminAccess'

const ShippingInquiryRoutes: RouteRecordRaw = {
  path: '/shipping-inquiry',
  name: 'ShippingInquiryModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'ManageShippingInquiryRoute',
      component: () => import('./views/ManageShippingInquiryView.vue'),
      meta: {
        title: 'درخواست‌های حمل باربری',
      },
    },
    {
      path: 'view/:id',
      name: 'ViewShippingInquiryRoute',
      component: () => import('./views/ShippingInquiryDetailsView.vue'),
      meta: {
        title: 'جزئیات درخواست حمل',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
    allowedRoles: MODULE_ACCESS.shippingInquiry,
  },
}

export default (router: Router) => {
  router.addRoute(ShippingInquiryRoutes)
}
